module.exports = __webpack_public_path__ + "media/team_photos/Orhan-Kose-photo-5a82d37d.webp";